// import React, { useState } from 'react';
// import './SportOneHero.scss';
// import { useFirestore } from '../../../../firebase-files/hooks/useFirestore';
// import { useCollection } from '../../../../firebase-files/hooks/useCollection';
// import { projectStorage } from '../../../../firebase-config/config';

// const SportOneHero = () => {
//   const { addDocument } = useFirestore("media");
//   const { documents: mediaDocuments, error: mediaError } = useCollection("media");

//   const [uploading, setUploading] = useState(false);

//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const storageRef = projectStorage.ref(`videos/${file.name}`);
//     setUploading(true);

//     try {
//       // console.log("Uploading to Firebase Storage...");
//       await storageRef.put(file);
//       const url = await storageRef.getDownloadURL();
//       // console.log("Upload successful. File URL:", url);

//       // console.log("Adding document to Firestore...");

//       await addDocument({
//         url,
//         name: file.name,
//         type: file.type,
//         createdAt: new Date(),
//       });
//       // console.log("Document added successfully!");
//       alert("Video uploaded and Firestore document created!");
//     } catch (err) {
//       console.error("Upload error:", err);
//       alert("Error uploading video.");
//     } finally {
//       setUploading(false);
//     }
//   };
//   // console.log("Fetched media documents from Firestore:", mediaDocuments);

//   // Sort documents by createdAt descending to get the most recent video
//   const latestVideo = mediaDocuments?.sort((a, b) => {
//     return b.createdAt?.toMillis() - a.createdAt?.toMillis();
//   })[0];
// //  console.log("Latest video selected:", latestVideo);

//   return (
//     <div>
//       <section className="sport-one-hero-section sport-one-fade-section">
//         <video
//           autoPlay
//           muted
//           loop
//           className="background-video"
//           src={latestVideo?.url || "/assets/img/sports/sport-one/videos/badminton-hero.mp4"}
//           type="video/mp4"
//         />
//         <div className="hero-content">
//           <span className="main-text">W18 SPORTS UNIVERSE</span>
//           <h1>ShuttlePro Badminton Academy</h1>
//           <p>A fitness movement that is worth breaking a sweat for</p>
//           <div className="cta-container">
//             <button className="cta-button" >Explore Membership</button>
//           </div>
//           <div className="arrow-icon">
//             <span style={{ fontSize: '1.2rem' }}>&#8595;</span>
//           </div>
//         </div>
//       </section>

//       <div className="upload-section">
//         <label className="cta-button" style={{ cursor: 'pointer' }}>
//           {uploading ? "Uploading..." : "Change Video"}
//           <input
//             type="file"
//             accept="video/*"
//             onChange={handleFileChange}
//             style={{ display: 'none' }}
//           />
//         </label>
//       </div>
//       <br />
//     </div>
//   );
// };

// export default SportOneHero;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SportOneHero.scss";
import { useFirestore } from "../../../../firebase-files/hooks/useFirestore";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
import { projectStorage } from "../../../../firebase-config/config";
import { useAuthContext } from "../../../../firebase-files/hooks/useAuthContext";

const SportOneHero = () => {
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const { addDocument } = useFirestore("media");
  const { documents: mediaDocuments, error: mediaError } =
    useCollection("media");

  const [uploading, setUploading] = useState(false);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const storageRef = projectStorage.ref(`videos/${file.name}`);
    setUploading(true);

    try {
      // console.log("Uploading to Firebase Storage...");
      await storageRef.put(file);
      const url = await storageRef.getDownloadURL();

      await addDocument({
        url,
        name: file.name,
        type: file.type,
        createdAt: new Date(),
      });
      alert("Video uploaded and Firestore document created!");
    } catch (err) {
      console.error("Upload error:", err);
      alert("Error uploading video.");
    } finally {
      setUploading(false);
    }
  };

  // Sort documents by createdAt descending to get the most recent video
  const latestVideo = mediaDocuments?.sort((a, b) => {
    return b.createdAt?.toMillis() - a.createdAt?.toMillis();
  })[0];

  return (
    <div>
      <section className="sport-one-hero-section sport-one-fade-section">
        <video
          autoPlay
          muted
          loop
          className="background-video"
          src={
            latestVideo?.url ||
            "/assets/img/sports/sport-one/videos/badminton-hero.mp4"
          }
          type="video/mp4"
        />
        <div className="hero-content">
          <span className="main-text">W18 SPORTS UNIVERSE</span>
          <h1>ShuttlePro Badminton Academy</h1>
          <p>A fitness movement that is worth breaking a sweat for</p>
          <div className="cta-container">
            <button
              className="cta-button"
              onClick={() => navigate("/products?category=Membership")}
            >
              Explore Membership
            </button>
          </div>
          <div className="arrow-icon">
            <span style={{ fontSize: "1.2rem" }}>&#8595;</span>
          </div>
        </div>
      </section>

      {user && user.role == "admin" && (
        <div className="upload-section">
          <label className="cta-button" style={{ cursor: "pointer" }}>
            {uploading ? "Uploading..." : "Change Video"}
            <input
              type="file"
              accept="video/*"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          </label>
        </div>
      )}
      <br />
    </div>
  );
};

export default SportOneHero;
